const datashipsConsole = () =>
  console.log(
    `%c ______________________________________
              __/___            
        _____/______|           
_______/_____\\_______\\_____     
\\              < < <       |    
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
There are tall ships and small ships and ships that sail the sea. But the best ships are Dataships so here's to you and me.`,
    "font-family:monospace; color: #10A4FF;",
  );

export default datashipsConsole;
